
import { useContext } from 'react'
import { FeatureFlagContext } from '../contexts/FeatureFlagContext'

/**
 * Custom hook to access feature flags
 * 
 * @returns {Object} Feature flag context value
 * @returns {Object} features - The feature flags object
 * @returns {boolean} loading - Loading state
 * @returns {string|null} error - Error message if any
 * @returns {Function} isFeatureEnabled - Check if a feature is enabled
 * @returns {Function} hasAnyFeature - Check if any of the provided features are enabled
 * @returns {Function} refreshFeatures - Manually refresh features from backend
 * 
 * @example
 * const { isFeatureEnabled, loading } = useFeatureFlag()
 * 
 * if (loading) return <Loading />
 * if (isFeatureEnabled('busManagement')) {
 *   return <BusManagementUI />
 * }
 */
export function useFeatureFlag() {
  const context = useContext(FeatureFlagContext)
  
  if (context === undefined) {
    throw new Error('useFeatureFlag must be used within a FeatureFlagProvider')
  }
  
  return context
}
